import { useMemo } from 'react';

import { expVal } from '@confluence/feature-experiments';

export const useEditorFullPageExperiments = (): {
	'table-drag-and-drop': boolean;
	'table-selector': boolean;
	'macro-interaction-updates': boolean;
	'table-with-fixed-column-widths-option': boolean;
	'more-elements-in-quick-insert-view': boolean;
} => {
	// IMPORTANT: If you add a new feature flag here, please make sure to add it to the
	// `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
	return useMemo(
		() => ({
			'table-drag-and-drop': expVal<boolean>(
				'platform_editor_tables_drag_and_drop',
				'isEnabled',
				false,
			),
			'table-selector': expVal<boolean>(
				'platform_editor_tables_table_selector',
				'isEnabled',
				false,
			),
			'macro-interaction-updates': true,
			'table-with-fixed-column-widths-option': true,
			'more-elements-in-quick-insert-view': true,
		}),
		[],
	);
};
